import React from "react";
import { useContent } from "../context/ContentContext";

export default function Services() {
  const { content } = useContent();
  const s = content.services || {};
  const items = s.items || [];
  const advisoryAreas = s.advisoryAreas || [];
  const targetAudience = s.targetAudience || [];
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{s.title || "Our Services"}</h1>
      <div className="row g-4 mb-4">
        {items.map((service, i) => (
          <div key={i} className="col-md-4">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <span style={{ fontSize: "2rem" }}>{service.icon || "📋"}</span>
                <h5 className="card-title text-success mt-2">{service.name}</h5>
                <p className="card-text">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <h3 className="text-warning">Advisory Areas</h3>
      <ul>
        {advisoryAreas.map((area, i) => <li key={i}>{area}</li>)}
      </ul>
      <h3 className="text-warning mt-3">Target Audience</h3>
      <ul>
        {targetAudience.map((aud, i) => <li key={i}>{aud}</li>)}
      </ul>
    </div>
  );
}
